import React from 'react';
import type { GlyphKind } from '../../utils/weather';

// The weather, drawn: one stroke weight (1.5, like the lucide icons around it),
// in whatever text colour the glyph sits in. No emoji anywhere (DESIGN.md).
export const GLYPH_KINDS: GlyphKind[] = ['rain', 'snow', 'sun', 'cold', 'cloud', 'none'];

const SHAPES: Record<GlyphKind, React.ReactNode> = {
  rain: (
    <>
      <path d="M6.5 15a4 4 0 0 1-.4-7.98A5.5 5.5 0 0 1 16.6 6.3 4.4 4.4 0 0 1 17 15Z" />
      <path d="M8.5 17.5 7.5 20M12.5 17.5l-1 2.5M16.5 17.5l-1 2.5" />
    </>
  ),
  snow: (
    <>
      <path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9" />
      <path d="M9.6 4.6 12 6l2.4-1.4M9.6 19.4 12 18l2.4 1.4" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
    </>
  ),
  cold: (
    <>
      <path d="M14 14.76V4.5a2 2 0 0 0-4 0v10.26a4 4 0 1 0 4 0Z" />
      <path d="M12 13.5v4M17 6.5h2.5M17 9.5h2.5" />
    </>
  ),
  cloud: <path d="M6.5 19a4.5 4.5 0 0 1-.4-8.98A6 6 0 0 1 17.6 9.2 4.9 4.9 0 0 1 17.5 19Z" />,
  // A hollow mark for "no forecast": the slot is there, the weather isn't.
  none: <circle cx="12" cy="12" r="7.5" strokeDasharray="2.5 3" />,
};

export default function WeatherGlyph({ kind, size = 20, title, className = '' }: {
  kind: GlyphKind; size?: number; title?: string; className?: string;
}) {
  // Beside words the glyph is decoration; standing alone it names itself.
  const a11y = title ? { role: 'img' } : { 'aria-hidden': true as const };
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5}
      strokeLinecap="round" strokeLinejoin="round" className={`shrink-0 ${className}`} {...a11y}
    >
      {title && <title>{title}</title>}
      {SHAPES[kind]}
    </svg>
  );
}
